module.exports = __webpack_public_path__ + "static/media/code.447e6cf5.svg";